"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareMessageToSign = exports.signOnDemandDataPackage = void 0;
const DataPackage_1 = require("../data-package/DataPackage");
const NumericDataPoint_1 = require("../data-point/NumericDataPoint");
const signOnDemandDataPackage = (address, score, timestamp, privateKey) => {
    const dataPoint = new NumericDataPoint_1.NumericDataPoint({
        dataFeedId: address,
        value: score,
        decimals: 0,
    });
    const dataPackage = new DataPackage_1.DataPackage([dataPoint], timestamp);
    return dataPackage.sign(privateKey);
};
exports.signOnDemandDataPackage = signOnDemandDataPackage;
const prepareMessageToSign = (timestamp) => {
    const utcDate = new Date(timestamp).toUTCString();
    return `Allow verification of my account on ${utcDate}`;
};
exports.prepareMessageToSign = prepareMessageToSign;
//# sourceMappingURL=on-demand-signer.js.map